import { render, staticRenderFns } from "./CCFooter.vue?vue&type=template&id=0ef42a45&scoped=true&"
import script from "./CCFooter.vue?vue&type=script&lang=js&"
export * from "./CCFooter.vue?vue&type=script&lang=js&"
import style0 from "./CCFooter.vue?vue&type=style&index=0&id=0ef42a45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef42a45",
  null
  
)

export default component.exports